import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "draggable"]

export interface propsComponent {
  isPreview: boolean;
}
import { ref, useAttrs, computed, withDefaults } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "VZDate",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const dateValue = ref();
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const restAttr = computed(() => {
  const { id, draggable, ...rest } = attrs;
  if (rest.style && rest.style.defaultBorder === "true !important") {
    rest.style.borderColor = "";
    rest.style.borderWidth = "";
    rest.style.borderStyle = "";
    rest.style.padding = "";
    rest.style.margin = "";
    rest.borderColor = "";
    rest.borderWidth = "";
    rest.borderStyle = "";
    rest.padding = "";
    rest.margin = "";
  }

  return rest;
});
const displayDate = computed(() => {
  return process.env.VUE_APP_DISPLAY_DATE || "MM-DD-YYYY";
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_BUTTON",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _createVNode(_component_el_date_picker, _mergeProps({
      type: "date",
      "value-format": "YYYY-MM-DD",
      format: _unref(displayDate),
      class: "w-100"
    }, _unref(restAttr), {
      modelValue: dateValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
      style: _unref(style),
      disabled: ""
    }), null, 16, ["format", "modelValue", "style"])
  ], 8, _hoisted_1))
}
}

})